
import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    paymentOrder: 'Payment Procedure',
    howItWorks: 'How the service works',
    contacts: 'Contacts',
    support: 'Support',
    refundTerms: 'Refund terms',
    digitalContent: 'Digital content',
    companyInfo: 'SHOT LIMITED · Company number 03002470\nRegents Plaza Apartments, 8 Greville Road, London, London, Flat 41',
  },
  ru: {
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    refundPolicy: 'Политика возвратов',
    paymentOrder: 'Порядок оплаты',
    howItWorks: 'Как работает сервис',
    contacts: 'Контакты',
    support: 'Поддержка',
    refundTerms: 'Условия возврата',
    digitalContent: 'Получение цифрового контента',
    companyInfo: 'SHOT LIMITED · Company number 03002470\nRegents Plaza Apartments, 8 Greville Road, London, London, Flat 41',
  },
  uz: {
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
    refundPolicy: 'Qaytarish siyosati',
    paymentOrder: "To'lov tartibi",
    howItWorks: 'Xizmat qanday ishlaydi',
    contacts: 'Kontaktlar',
    support: "Qo'llab-quvvatlash",
    refundTerms: 'Qaytarish shartlari',
    digitalContent: 'Raqamli kontent olish',
    companyInfo: 'SHOT LIMITED · Company number 03002470\nRegents Plaza Apartments, 8 Greville Road, London, London, Flat 41',
  },
});
